// Prettify a chain slug for display: "trgovina-krk" -> "Trgovina Krk".
// Unicode-aware: only the first letter after the start or a space is upper-cased,
// so Croatian diacritics mid-word survive ("košara" -> "Košara", not "KošAra" —
// the old ASCII \b\w treated š/ć/ž as a word boundary).
export function prettyChain(slug) {
  return String(slug)
    .replace(/[-_]+/g, ' ')
    .replace(/(^|\s)(\p{L})/gu, (_m, sep, ch) => sep + ch.toUpperCase())
}

// Anonymised chain identities for masked mode (see services/maskMode.js).
//
// Labels are assigned by POSITION in the rendered list, not per chain: on the
// results page that is price rank, so the cheapest row is always "Kosara". This
// guarantees a stable top row without inventing names for all 29 chains, avoids
// two identically-labelled rows, and keeps the mapping non-decodable since a
// label does not follow a chain across products.
//
// Palette carried over from design/og-results-shot.mjs: reds, blues, orange and
// navy so the chips read as plausible logo tiles. Green is deliberately absent --
// it is the app's "cheapest" signal and would fight the winner styling. Names are
// generic Croatian shop words, checked against every real chain in the data.
export const MASK_LABELS = [
  { label: 'Ko\u0161ara',        letter: 'K',            bg: '#d81f2a' },
  { label: 'Market',              letter: 'M',            bg: '#0a53a8' },
  { label: 'Diskont',             letter: 'D',            bg: '#d9560f' },
  { label: 'Trgovina',            letter: 'T',            bg: '#16386b' },
  { label: 'Du\u0107an',         letter: 'D',            bg: '#b31217' },
  { label: '\u0160peceraj',      letter: '\u0160',      bg: '#6b21a8' },
  { label: 'Samoposluga',         letter: 'S',            bg: '#0e7490' },
  { label: 'Bazar',               letter: 'B',            bg: '#92400e' },
  { label: 'Nabava',              letter: 'N',            bg: '#3730a3' },
  { label: 'Ekonomik',            letter: 'E',            bg: '#7f1d1d' },
  { label: 'Robna',               letter: 'R',            bg: '#334155' },
  { label: 'Pijaca',              letter: 'P',            bg: '#86198f' },
  { label: 'Veletrgovina',        letter: 'V',            bg: '#1d4ed8' },
  { label: 'Zadruga',             letter: 'Z',            bg: '#a16207' },
  { label: 'Lanac',               letter: 'L',            bg: '#1f2937' },
  { label: 'Opskrba',             letter: 'O',            bg: '#9a3412' },
  { label: 'Skladi\u0161te',     letter: 'S',            bg: '#57534e' },
  { label: 'Potro\u0161a\u010d', letter: 'P',           bg: '#701a75' },
  { label: 'Kvart',               letter: 'K',            bg: '#374151' },
  { label: 'Namirnice',           letter: 'N',            bg: '#831843' },
]

// Masked identity for the row at `index`. Degrades to a numbered label past the
// end of the pool rather than wrapping, so no list can show a duplicate.
export function maskedChain(index) {
  const i = Number(index) || 0
  return MASK_LABELS[i] ?? { label: `Trgovina ${i + 1}`, letter: 'T', bg: '#4b5563' }
}

// Name to show for a chain: the anonymised label when masked mode is on, the
// prettified slug otherwise.
export function displayChain(slug, index = 0, masked = false) {
  return masked ? maskedChain(index).label : prettyChain(slug)
}
